import { SponsorTags } from "components/layout/sponsors/SponsorTags";
import { SponsoredContent as BaseSponsoredContent } from "graphql/generated/types";

export type SponsoredContent = Omit<BaseSponsoredContent, "sponsor"> & {
    sponsor: Omit<BaseSponsoredContent["sponsor"], "organisation">
}

export type EventCardSponsorsProps = {
    sponsoredContents: SponsoredContent[] | null | undefined
}

export const EventCardSponsors: React.FC<EventCardSponsorsProps> = ({ sponsoredContents }) => {
    if (!sponsoredContents || sponsoredContents.length === 0) return null;

    return <SponsorTags sponsoredContents={sponsoredContents} />;
};
